export interface OtpMetadata {
  // Path A age gate (#1006): a self-declared 18+ affirmation persisted to the
  // Supabase user's metadata. No DOB is stored — this stays within the
  // minimal-PII posture while giving an auditable record the adult
  // affirmation was made at signup.
  age_confirmed?: boolean;
  age_confirmed_at?: string;
  first_name?: string;
  last_name?: string;
}

export function buildOtpOptions(
  metadata: OtpMetadata | undefined,
  options: { shouldCreateUser?: boolean } | undefined
) {
  return {
    data: metadata,
    shouldCreateUser: options?.shouldCreateUser ?? true,
  };
}
